import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Grow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { handleLogout } from "../utilities/common";
import cookieStorage from "../utilities/cookie_storage";


const AlertDialog = ({
  title,
  openDialog,
  handleClose,
  handleAction,
  handleCancelBtn,
  loading,
  actionText,
  cancelBtnText,
  loadingText,
  children,
  backdropClose,
  dialogStyles,
  actionBtnDisabled,
  ...props
}) => {

  const userName = cookieStorage.getItem("user_name");

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleDialogClose = (event, reason) => {
    // Prevent closing if the reason is "backdropClick" or "escapeKeyDown"
    if (
      backdropClose &&
      (reason === "backdropClick" || reason === "escapeKeyDown")
    ) {
      return;
    }
    if (handleClose) {
      handleClose();
    }
  };

  const handleClickProfile = (e) => {
    setAnchorEl(e?.currentTarget);
  };

  const onLogout = () => {
    handleLogout();
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={false}
      slots={{ transition: Grow }}
      slotProps={{
        backdrop: {
          style: {
            backgroundColor: props?.backdropColor || 'rgba(255, 255, 255, .5)'
          }
        },
        transition: { timeout: 300 },
        paper: {
          width: props?.alertWidth || "fit-content",
          maxWidth: "90vw",
          minWidth: "25vw",
          margin: "auto",
          boxShadow: 'none',
          border: '1px solid #d9d9d9',
          ...dialogStyles
        }

      }}
    >
      {title ? (
        <DialogTitle
          id="alert-dialog-title"
          className="flex items-center justify-between w-full gap-12"
        >
          {title || ""}
          {props?.noCloseIcon ? null : (
            <CloseIcon
              fontSize="inherit"
              sx={{ color: "grey" }}
              className="cursor-pointer"
              onClick={handleDialogClose}
            />
          )}
        </DialogTitle>
      ) : null}
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="flex flex-col"
          style={{ whiteSpace: "nowrap" }}
        >
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={`px-6 pb-6 ${props?.dialogActionBtnStyles ? props?.dialogActionBtnStyles : ''}`}>
        {props?.noCancelBtn ? null : (
          <Button
            variant="contained"
            className="alert-cancel-btn"
            onClick={cancelBtnText ? handleCancelBtn : handleClose}
          >
            {cancelBtnText || 'Cancel'}
          </Button>
        )}
        {props?.noActionBtn ? null : (
          <Button
            variant="contained"
            className={`save-btn ${props?.actionBtnStyles ? props?.actionBtnStyles : ''}`}
            onClick={handleAction}
            autoFocus
            disabled={loading || actionBtnDisabled}
          >
            {loading ? loadingText || "Loading..." : actionText || "Save"}
          </Button>
        )}
      </DialogActions>
      {backdropClose && props?.showLogout && (
        <>
          <IconButton
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClickProfile}
            sx={{
              position: "fixed",
              top: 0,
              right: 3,
              backgroundColor: "transparent",
              cursor: "pointer",
            }}
          >
            <div className="user-profile-icon flex items-center justify-center cursor-pointer">
              {userName?.[0] || "P"}
            </div>
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={onLogout}>Logout</MenuItem>
          </Menu>
        </>
      )}
    </Dialog>
  );
};

export default AlertDialog;
